/*
  PDP gallery — "stack + rail" (referencia: pourri.com PDP).

  Desktop (>= 990px):
    - Todas las medias quedan apiladas dentro de un panel con scroll interno (CSS).
    - Click en miniatura => scroll interno suave hasta esa media, sin mover la pagina.
    - El scroll del panel sincroniza la miniatura activa.
    - Riel de miniaturas con flechas arriba/abajo propias.

  Movil/tablet: no hace nada, se respeta el carrusel nativo de Dawn.
*/
(function () {
  const DESKTOP = '(min-width: 990px)';
  const CARET =
    '<svg viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 1 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" fill="currentColor"/></svg>';

  // Animacion de scroll propia: el scroll suave nativo (behavior: 'smooth') se
  // cancela dentro de este contenedor en varios navegadores.
  function animateScrollTop(element, to, duration = 420) {
    // `to` puede ser un numero o una funcion: se reevalua en cada frame porque las
    // imagenes lazy cambian scrollHeight/offsetTop mientras se anima.
    const resolve = () => {
      const desired = typeof to === 'function' ? to() : to;
      const max = Math.max(0, element.scrollHeight - element.clientHeight);
      return Math.max(0, Math.min(desired, max));
    };
    const from = element.scrollTop;
    if (element._stackScrollFrame) cancelAnimationFrame(element._stackScrollFrame);
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
      element.scrollTop = resolve();
      return;
    }
    const start = performance.now();
    const step = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      element.scrollTop = from + (resolve() - from) * eased;
      if (t < 1) element._stackScrollFrame = requestAnimationFrame(step);
      else {
        element.scrollTop = resolve();
        element._stackScrollFrame = null;
      }
    };
    element._stackScrollFrame = requestAnimationFrame(step);
  }

  function animateScrollLeft(element, to, duration = 380) {
    const from = element.scrollLeft;
    const max = Math.max(0, element.scrollWidth - element.clientWidth);
    const target = Math.max(0, Math.min(to, max));
    if (element._stackScrollXFrame) cancelAnimationFrame(element._stackScrollXFrame);
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
      element.scrollLeft = target;
      return;
    }
    const start = performance.now();
    const step = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      element.scrollLeft = from + (target - from) * eased;
      if (t < 1) element._stackScrollXFrame = requestAnimationFrame(step);
      else element._stackScrollXFrame = null;
    };
    element._stackScrollXFrame = requestAnimationFrame(step);
  }

  class StackGallery {
    constructor(gallery) {
      this.gallery = gallery;
      this.list = gallery.querySelector('.product__media-list');
      this.rail = gallery.querySelector('.thumbnail-list');
      this.railWrapper = gallery.querySelector('.thumbnail-slider');
      this.mql = window.matchMedia(DESKTOP);
      this.enabled = false;

      if (!this.list || !this.rail || !this.railWrapper) return;

      this.onThumbClick = this.onThumbClick.bind(this);
      this.onRailScroll = this.onRailScroll.bind(this);
      this.onListScroll = this.onListScroll.bind(this);
      this.blockSlideChanged = (event) => event.stopPropagation();
      this.sync = this.sync.bind(this);

      this.buildRailButtons();
      this.buildMobileProgress();
      this.mql.addEventListener('change', this.sync);
      this.sync();
    }

    // Movil: barra de progreso bajo el carrusel (la referencia no muestra miniaturas).
    buildMobileProgress() {
      const buttons = this.gallery.querySelector('.slider-buttons');
      if (!buttons) return;

      this.progress = document.createElement('div');
      this.progress.className = 'stack-progress';
      this.progressThumb = document.createElement('span');
      this.progressThumb.className = 'stack-progress__thumb';
      this.progress.appendChild(this.progressThumb);

      const counter = buttons.querySelector('.slider-counter');
      if (counter) counter.insertAdjacentElement('afterend', this.progress);
      else buttons.appendChild(this.progress);

      this.updateProgress = this.updateProgress.bind(this);
      this.list.addEventListener('scroll', this.updateProgress, { passive: true });
      window.addEventListener('resize', this.updateProgress);
      this.updateProgress();

      // Dawn mide el ancho de slide al inicializar, cuando las imagenes lazy aun
      // no tienen tamano: sliderItemOffset queda en 0 y las flechas no avanzan.
      this.refreshDawnSlider();
      window.setTimeout(() => this.refreshDawnSlider(), 800);
      window.addEventListener('load', () => this.refreshDawnSlider());

      // Las flechas de Dawn usan scrollTo({behavior:'smooth'}), que el navegador
      // cancela mientras cargan las imagenes lazy. Movemos nosotros el carrusel.
      buttons.addEventListener(
        'click',
        (event) => {
          const button = event.target.closest('.slider-button');
          if (!button || window.matchMedia(DESKTOP).matches) return;
          event.preventDefault();
          event.stopPropagation();
          this.refreshDawnSlider();
          const step = this.slideStep();
          const direction = button.name === 'next' ? 1 : -1;
          animateScrollLeft(this.list, this.list.scrollLeft + direction * step);
        },
        true
      );
    }

    slideStep() {
      const items = this.list.querySelectorAll('.product__media-item');
      if (items.length > 1) return items[1].offsetLeft - items[0].offsetLeft;
      return this.list.clientWidth;
    }

    refreshDawnSlider() {
      const slider = this.gallery.querySelector('slider-component[id^="GalleryViewer"]');
      if (!slider || typeof slider.initPages !== 'function') return;
      slider.initPages();
      if (typeof slider.update === 'function') slider.update();
    }

    updateProgress() {
      if (!this.progress) return;
      if (this.progressFrame) return;
      this.progressFrame = requestAnimationFrame(() => {
        this.progressFrame = null;
        const scrollable = this.list.scrollWidth - this.list.clientWidth;
        if (scrollable <= 1) {
          this.progress.hidden = true;
          return;
        }
        this.progress.hidden = false;
        const ratio = this.list.clientWidth / this.list.scrollWidth;
        const position = this.list.scrollLeft / scrollable;
        this.progressThumb.style.width = `${Math.max(ratio * 100, 12)}%`;
        this.progressThumb.style.left = `${position * (100 - Math.max(ratio * 100, 12))}%`;
      });
    }

    sync() {
      if (this.mql.matches) this.enable();
      else this.disable();
    }

    enable() {
      if (this.enabled) return;
      this.enabled = true;

      // Capturamos el click antes que media-gallery.js para evitar su scroll de pagina.
      this.rail.addEventListener('click', this.onThumbClick, true);
      this.rail.addEventListener('scroll', this.onRailScroll, { passive: true });

      this.list.addEventListener('scroll', this.onListScroll, { passive: true });

      // El slider horizontal de Dawn calcula paginas al hacer scroll y dispara
      // 'slideChanged' con un elemento inexistente en esta vista vertical
      // (TypeError en media-gallery.js). Lo cortamos en fase de captura.
      this.gallery.addEventListener('slideChanged', this.blockSlideChanged, true);

      // Si Dawn cambia la media activa (p.ej. al cambiar de variante), seguimos el cambio
      // con scroll interno en lugar de dejar que salte la pagina.
      this.mutationObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          const target = mutation.target;
          // Solo reaccionamos si el cambio NO lo hicimos nosotros (this.currentId).
          if (target.classList.contains('is-active') && target.dataset.mediaId !== this.currentId) {
            this.currentId = target.dataset.mediaId;
            this.scrollListTo(target);
            this.setActiveThumb(this.currentId);
            break;
          }
        }
      });
      this.list.querySelectorAll('.product__media-item[data-media-id]').forEach((item) => {
        this.mutationObserver.observe(item, { attributes: true, attributeFilter: ['class'] });
      });

      // Estado inicial: primera media arriba del panel y su miniatura marcada.
      // (las imagenes lazy pueden desplazar el scroll del contenedor al cargar)
      const first = this.list.querySelector('.product__media-item[data-media-id]');
      if (first) {
        this.setActive(first.dataset.mediaId, { scrollList: false });
        this.list.scrollTop = 0;
        const settle = () => {
          if (this.userScrolled) return;
          this.list.scrollTop = 0;
        };
        window.setTimeout(settle, 300);
        window.setTimeout(() => {
          settle();
          this.readyForUserScroll = true;
        }, 1200);
      }

      this.updateRailButtons();
    }

    disable() {
      if (!this.enabled) return;
      this.enabled = false;
      this.rail.removeEventListener('click', this.onThumbClick, true);
      this.rail.removeEventListener('scroll', this.onRailScroll);
      this.list.removeEventListener('scroll', this.onListScroll);
      this.gallery.removeEventListener('slideChanged', this.blockSlideChanged, true);
      if (this.mutationObserver) this.mutationObserver.disconnect();
    }

    // La media activa es la que ocupa la banda superior del panel.
    onListScroll() {
      if (this.readyForUserScroll) this.userScrolled = true;
      if (this.listScrollFrame) return;
      this.listScrollFrame = requestAnimationFrame(() => {
        this.listScrollFrame = null;
        const items = Array.from(this.list.querySelectorAll('.product__media-item[data-media-id]'));
        if (!items.length) return;
        const origin = items[0].offsetTop;
        const probe = this.list.scrollTop + this.list.clientHeight * 0.35;
        let current = items[0];
        for (const item of items) {
          if (item.offsetTop - origin <= probe) current = item;
        }
        this.setActive(current.dataset.mediaId, { scrollList: false });
        this.updateRailButtons();
      });
    }

    onThumbClick(event) {
      const item = event.target.closest('.thumbnail-list__item');
      if (!item || !item.dataset.target) return;
      event.preventDefault();
      event.stopPropagation();
      this.setActive(item.dataset.target, { scrollList: true });
    }

    setActive(mediaId, { scrollList }) {
      if (!mediaId) return;
      const media = this.list.querySelector(`.product__media-item[data-media-id="${mediaId}"]`);
      if (!media) return;

      this.currentId = mediaId;
      this.list.querySelectorAll('.product__media-item[data-media-id]').forEach((el) => el.classList.remove('is-active'));
      media.classList.add('is-active');

      if (scrollList) this.scrollListTo(media);
      this.setActiveThumb(mediaId);
    }

    scrollListTo(media) {
      if (!media || !this.list) return;
      animateScrollTop(this.list, () => {
        const first = this.list.querySelector('.product__media-item[data-media-id]');
        return media.offsetTop - (first ? first.offsetTop : 0);
      });
    }

    setActiveThumb(mediaId) {
      const item = this.rail.querySelector(`[data-target="${mediaId}"]`);
      if (!item) return;
      this.rail.querySelectorAll('button').forEach((button) => button.removeAttribute('aria-current'));
      const button = item.querySelector('button');
      if (button) button.setAttribute('aria-current', 'true');

      const firstThumb = this.rail.querySelector('.thumbnail-list__item');
      const origin = firstThumb ? firstThumb.offsetTop : 0;
      const itemTop = item.offsetTop - origin;
      const itemBottom = itemTop + item.offsetHeight;
      if (itemTop < this.rail.scrollTop) {
        animateScrollTop(this.rail, itemTop);
      } else if (itemBottom > this.rail.scrollTop + this.rail.clientHeight) {
        animateScrollTop(this.rail, itemBottom - this.rail.clientHeight);
      }
    }

    buildRailButtons() {
      const step = () => {
        const first = this.rail.querySelector('.thumbnail-list__item');
        return first ? (first.offsetHeight + 8) * 3 : 240;
      };

      this.prevButton = this.makeRailButton('prev', () =>
        animateScrollTop(this.rail, this.rail.scrollTop - step())
      );
      this.nextButton = this.makeRailButton('next', () =>
        animateScrollTop(this.rail, this.rail.scrollTop + step())
      );

      this.railWrapper.insertBefore(this.prevButton, this.rail);
      this.railWrapper.appendChild(this.nextButton);
    }

    makeRailButton(direction, onClick) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `stack-rail-button stack-rail-button--${direction}`;
      button.innerHTML = CARET;
      button.setAttribute(
        'aria-label',
        direction === 'prev' ? 'Ver miniaturas anteriores' : 'Ver miniaturas siguientes'
      );
      button.addEventListener('click', onClick);
      return button;
    }

    onRailScroll() {
      this.updateRailButtons();
    }

    updateRailButtons() {
      if (!this.prevButton || !this.nextButton) return;
      const overflows = this.rail.scrollHeight - this.rail.clientHeight > 12;
      this.prevButton.hidden = !overflows;
      this.nextButton.hidden = !overflows;
      if (!overflows) return;
      this.prevButton.disabled = this.rail.scrollTop <= 1;
      this.nextButton.disabled = this.rail.scrollTop + this.rail.clientHeight >= this.rail.scrollHeight - 1;
    }
  }

  // Zoom inline (magnify.js de Dawn): marca las imagenes de la galeria para que
  // magnify.js, cargado justo despues de este script, les enganche el click.
  // Solo desktop: en movil/tablet el click sigue abriendo el lightbox de Dawn.
  const markMagnifiable = () => {
    if (!window.matchMedia(DESKTOP).matches) return;
    document
      .querySelectorAll('.pdp-gallery-stack .product__media-list .product__media img')
      .forEach((image) => image.classList.add('image-magnify-hover'));
  };

  const init = () => {
    document.querySelectorAll('.pdp-gallery-stack media-gallery').forEach((gallery) => {
      if (gallery.dataset.stackGallery === 'true') return;
      gallery.dataset.stackGallery = 'true';
      // Productos de una sola media: Dawn no renderiza miniaturas, asi que el
      // riel no debe reservar columna.
      if (!gallery.querySelector('.thumbnail-slider')) gallery.classList.add('stack-single-media');
      new StackGallery(gallery);
    });
  };

  // Dawn reemplaza el HTML de la galeria al cambiar de variante: hay que volver a
  // inicializar sobre los nodos nuevos.
  const watchForRerenders = () => {
    document.querySelectorAll('.pdp-gallery-stack .product__media-wrapper').forEach((wrapper) => {
      new MutationObserver(() => {
        const gallery = wrapper.querySelector('media-gallery');
        if (!gallery || gallery.dataset.stackGallery === 'true') return;
        markMagnifiable();
        enableZoomOnHoverAgain();
        init();
      }).observe(wrapper, { childList: true });
    });
  };

  // magnify.js expone enableZoomOnHover() en el scope global al cargarse.
  const enableZoomOnHoverAgain = () => {
    if (typeof window.enableZoomOnHover === 'function') window.enableZoomOnHover(2);
  };

  // Se ejecuta con defer: el DOM ya esta parseado y magnify.js corre despues.
  markMagnifiable();

  window.matchMedia(DESKTOP).addEventListener('change', () => {
    markMagnifiable();
    enableZoomOnHoverAgain();
  });

  const boot = () => {
    init();
    watchForRerenders();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
